function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: "256",
  y1: "514",
  x2: "256",
  y2: "2",
  gradientTransform: "matrix(1 0 0 -1 0 514)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0",
  stopColor: "#68b0db"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#468cc3"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Icons"
}, /*#__PURE__*/React.createElement("g", {
  id: "Snagit"
}, /*#__PURE__*/React.createElement("g", {
  id: "Snagit_Icon_256px",
  "data-name": "Snagit Icon 256px"
}, /*#__PURE__*/React.createElement("rect", {
  width: "512",
  height: "512",
  rx: "50",
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d8ebf6",
  d: "M93 140h78v77H93zM341 295h78v77h-78z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M155.7 374.42l-60.41 62A8 8 0 00101 450h238.68a8 8 0 005.73-2.42L419.05 372H161.43a8 8 0 00-5.73 2.42zM356.36 137.58l60.41-62A8 8 0 00411 62H172.37a8 8 0 00-5.73 2.42L93 140h257.63a8 8 0 005.73-2.42zM345.38 219.42a8 8 0 00-5.73-2.42H93l73.64 75.58a8 8 0 005.73 2.42H419z",
  fill: "#fff"
})))));